import { anyOf, objectOf, maybe } from "@altostra/type-validations";
import { boolean, string, number, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

const isRequestFound = objectOf({
  request_id: string,
  estimated_time_remaining: anyOf(number, nullOrUndefined),
  progress_percentage: number,
  initiator_email: maybe(string),
  app_group_id: maybe(string),
  segment_id: maybe(string), // remove when deprecating FF "generic_async_request_params"
  segment_name: maybe(string), // remove when deprecating FF "generic_async_request_params"
  entity_id: maybe(string),
  entity_name: maybe(string),
  entity_type: maybe(string),
});

const isRequestNotFound = objectOf({
  not_found: boolean,
});

export const isAsyncRequestManagerFindRequestResult = anyOf(isRequestFound, isRequestNotFound);
